import { render } from "./DropdownValuesModal.vue?vue&type=template&id=0496402c&scoped=true"
import script from "./DropdownValuesModal.vue?vue&type=script&lang=js"
export * from "./DropdownValuesModal.vue?vue&type=script&lang=js"

import "./DropdownValuesModal.vue?vue&type=style&index=0&id=0496402c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0496402c"]])

export default __exports__